<!--机构管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="0" :ssid="ssid"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="机构名称： ">
                  <el-input
                    placeholder="请输入机构名称..."
                    v-model="search.COMPANY_NAME"
                  ></el-input>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="60vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            ></el-table-column>
          </template>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 模版下载 form表单 开始 -->
      <form :action="action" ref="crkForm" target="_blank" method="post">
        <input type="text" name="op" v-model="op" style="display:none" />
        <input
          type="text"
          name="objData"
          v-model="objDataParam"
          style="display:none"
        />
      </form>
      <!-- 模版下载 form表单 开始 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "JgGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {
        COMPANY_NAME: ""
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "COMPANY_NAME",
          colText: "机构名称",
          colShow: true
        },
        {
          colName: "ZTM",
          colText: "总条目",
          colShow: true
        }
      ],
      tableData: []
    };
  },
  created() {
    this.op = "adminInstitutionGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    /**分页方法 结束 */
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/jgGlIndex/JgGlIndex.vue